/* global squiz */

/**
 * data-lightbox-special - vars.action -
 * by using "data-lightbox-special" you are able to for example pick another selector (it work only on "data-lightbox-ajax-site" )
 *
 * Note: Thank you page need to be wraped by div with class "lb-thankyou"
 */

[...document.querySelectorAll(".lightbox")].map((el) =>
    el.classList.add("lightbox--js")
);

const lightBox = {
    selectors: {
        lightboxItems: document.querySelectorAll(".lightbox--js"),
        lightboxCloseButtons: document.querySelectorAll(
            ".lightbox__button--js-close-lightbox"
        ),
        lightboxBox: document.querySelector(".lightbox__box"),
        lightboxContentBox: document.querySelector(".lightbox__content"),
        lightboxSubmitButton: document.querySelector(".lightbox__button--send"),
    },
    cls: {
        lightboxDelay: ".lightbox-delay--js",
        lightboxTrigger: ".lightbox--js",
    },
    vars: {
        itItInternalLink: true,
        action: "",
        pageUrl: "woodplc.com",
        lvlOfLightboxInLightbox: 0,
    },
    delayedInit() {
        let delayedLightboxesObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (!mutation.addedNodes) return;

                for (let i = 0; i < mutation.addedNodes.length; i++) {
                    let node = mutation.addedNodes[i];
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const lightboxes = [
                            ...node.querySelectorAll(this.cls.lightboxTrigger),
                        ];
                        lightboxes.forEach((lightboxOpener) => {
                            lightboxOpener.addEventListener("click", (e) =>
                                this.lightboxOpenClickHandler(e)
                            );
                        });
                    }
                }
            });
        });

        const delayedLightboxNodes = [
            ...document.querySelectorAll(this.cls.lightboxDelay),
        ];

        delayedLightboxNodes.forEach((delayedLightboxNode) => {
            delayedLightboxesObserver.observe(delayedLightboxNode, {
                childList: true,
                subtree: true,
                attributes: false,
                characterData: false,
            });
        });
        this.integrateReCaptcha();
    },
    init() {
        [...this.selectors.lightboxItems].forEach((item) => {
            item.addEventListener("click", (e) =>
                this.lightboxOpenClickHandler(e)
            );
        });

        // close buttons
        [...this.selectors.lightboxCloseButtons].forEach((closeButton) => {
            closeButton.addEventListener(
                "click",
                this.lightboxCloseClickHandler
            );
        });

        this.delayedInit();
    },
    integrateReCaptcha() {
        const targetNode = document.querySelector(".page-wrapper");
        const injectCaptcha = async () => {
            const formContainer = document.querySelector(
                        ".form-lightbox__container"
                    );
            const script = document.createElement("script");
            const recaptchaBtn = document.createElement("div");
            recaptchaBtn.classList.add("g-recaptcha");
            recaptchaBtn.classList.add("async-recaptcha");
            recaptchaBtn.setAttribute("data-theme", "light");
            recaptchaBtn.setAttribute("data-size", "normal");
            recaptchaBtn.setAttribute(
                "data-sitekey",
                "6LcBCugfAAAAALA1Q8oUqwxlaBbU0HOP3r2tO7vu"
            );

            const reCaptchaContainer =
                document.querySelector(".form-recaptcha-container") || null;
            reCaptchaContainer?.childNodes.forEach((child) => {
                child.remove();
            });
            reCaptchaContainer?.appendChild(recaptchaBtn);
            script.src = "https://www.google.com/recaptcha/api.js";
            reCaptchaContainer?.appendChild(script);
            formContainer?.classList.add('has-recaptcha');
            proxy.value = false;
            return;
        };
        const isInjectNeeded = {
            value: false,
        };
        const proxy = new Proxy(isInjectNeeded, {
            set: function (target, key, value) {
                target[key] = value;
                if (isInjectNeeded.value) {
                    injectCaptcha();
                }
                return;
            },
        });
        const observeForm = (mutationList) => {
            const excludedNode = document.querySelector(
                ".form-recaptcha-container"
            ) || null;
            for (const mutation of mutationList) {
                if (
                    mutation.target === excludedNode || mutation.target === document.querySelector('.g-recaptcha') ||
                    (excludedNode &&
                        [...excludedNode.childNodes].includes(mutation.target))
                ) {
                    return;
                }
            }
            if (document.querySelector(".lightbox-section") && !document.querySelector('.has-recaptcha')) {
                proxy.value = true;
            }
        };
        const observerConfig = {
            childList: true,
            subtree: true,
        };
        const formObserver = new MutationObserver(observeForm);
        formObserver.observe(targetNode, observerConfig);
    },
    lightboxOpenClickHandler(e) {
        const target = e.currentTarget,
            dataAttr = [...target.attributes].filter(
                (el) =>
                    el.name.includes("data-lightbox-ajax-") ||
                    el.name.includes("data-lightbox-video")
            )[0]; //obj with name and value
        this.vars.action = target.getAttribute("data-lightbox-special") || "";

        e.preventDefault();
        squiz.fn.loadSpiner("show");
        if (this.vars.lvlOfLightboxInLightbox > 0) {
            squiz.fn.lightboxClean();
        }
        dataAttr.name && dataAttr.name === "data-lightbox-video"
            ? squiz.fn.appendVideo(this.selectors.lightboxContentBox, dataAttr)
            : this.fetchinglightboxData(dataAttr, target);
    },
    /**
     *
     * @param dataAttr {obj} - {name: attrName, value: attrValue}
     * @param target  - e.currentTarget
     */
    fetchinglightboxData(dataAttr, target) {
        var url = dataAttr.value;

        if (dataAttr.value.includes(this.vars.pageUrl)) {
            // check "data-lightbox-special" attribute
            switch (this.vars.action) {
                case "profile":
                    url = url + "?SQ_DESIGN_NAME=blank";
                    break;
                case "subscribe":
                case "":
                    url = url + "?SQ_ASSET_CONTENTS_RAW";
                    break;
                default:
                    // no changes
                    break;
            }
        } else {
            this.vars.action = "external";
        }

        fetch(url)
            .then((response) => {
                switch (dataAttr.name) {
                    case "data-lightbox-ajax-site":
                        return response.text();

                    default:
                        return null;
                }
            })
            .then((data) => {
                switch (dataAttr.name) {
                    case "data-lightbox-ajax-site":
                        this.displaingFetchHtml(data, dataAttr, target);
                        break;

                    default:
                        return null;
                }
            })
            .catch(function (err) {
                console.warn("Something went wrong.", err);
                squiz.fn.loadSpiner("hide");
            });
    },

    /**
     * @desc - Append html from fetch to '.lightbox__content'
     * @param data {obj} - data from fetch
     * @param dataAttr {obj} - {name: attrName, value: attrValue}
     * @param target  - e.currentTarget
     */
    displaingFetchHtml(data, dataAttr, target) {
        const parser = new DOMParser(),
            doc = parser.parseFromString(data, "text/html");
        let contentToAdd;

        // support lightbox in lightbox
        [...doc.querySelectorAll(".lightbox")].map((item) => {
            item.addEventListener("click", (e) =>
                this.lightboxOpenClickHandler(e)
            );
        });
        this.vars.lvlOfLightboxInLightbox++;

        // by using "data-lightbox-special" you are able to pick another selector (it work only on "data-lightbox-ajax-site" )
        // if(dataAttr.name === 'data-lightbox-ajax-site') {

        switch (this.vars.action) {
            case "external":
                contentToAdd = doc.querySelector("body");
                break;

            case "profile":
                contentToAdd = doc.querySelector(".profile-page");
                break;

            // case 'subscribe':
            //     contentToAdd = doc.querySelector('.lb-form');
            //     break;

            default:
                contentToAdd = doc.querySelector("html");
                break;
        }
        // }

        // if submit button with class '.sq-form-submit' exist
        if (doc.querySelector(".sq-form-submit")) {
            switch (this.vars.action) {
                // email is nesesery to send mail to properly pleace
                // backUrl is nesesery to support back button
                case "profile-open":
                    var email = target.getAttribute("data-lightbox-email");
                    var backUrl = target.getAttribute("data-lightbox-back");
                    contentToAdd =
                        doc.querySelector("form.lb-form") ||
                        doc.querySelector(".lb-form");
                    var backButton = contentToAdd.querySelector(
                        ".form-lightbox__back--link"
                    );
                    var emailHandler = contentToAdd.querySelector(
                        ".hidden-email input"
                    );

                    if (backButton) {
                        backButton.setAttribute(
                            "data-lightbox-ajax-site",
                            backUrl
                        ); //--  back
                        localStorage.setItem("targetBackUrl", backUrl);

                        backButton.addEventListener("click", () => {
                            lightBox.vars.lvlOfLightboxInLightbox =
                                lightBox.vars.lvlOfLightboxInLightbox - 2;
                        });
                    }

                    if (emailHandler && email) {
                        emailHandler.value = email;
                        localStorage.setItem("targetEmail", email);
                    }

                    break;

                default:
                    contentToAdd =
                        doc.querySelector("form.lb-form") ||
                        doc.querySelector(".lb-form");
                    break;
            }
        }

        squiz.fn.loadSpiner("hide");
        squiz.fn.lightboxActions("show");
        try {
            if (doc.querySelector(".sq-form-submit")) {
                this.changingSubmit(contentToAdd);
            }
            this.selectors.lightboxContentBox.appendChild(contentToAdd);
            if (contentToAdd.querySelector("select")) {
                squiz.fn.runCustomSelect();
            }
        } catch (error) {
            console.error(error);
            squiz.fn.lightboxActions("hide");
        }
    },

    /**
     * @desc - hideing form submit and ading new unther the page.
     * @param parsedHTML {node?} - data from fetch but parsered to 'text/html'
     */
    changingSubmit(parsedHTML) {
        // do only if form have select with "sq-form-submit" class
        if (parsedHTML.querySelector(".sq-form-submit")) {
            this.selectors.lightboxSubmitButton.classList.remove("hidden");
            this.selectors.lightboxSubmitButton.addEventListener(
                "click",
                this.sendForm
            ); //() => this.sendForm()
            parsedHTML
                .querySelector(".sq-form-submit")
                .classList.add("sr-only");
        }
    },

    /**
     * @desc - geting data from lightbox form
     */
    getDataFromLightboxForm() {
        const form = document.querySelector(".lightbox__content form"),
            formData = new FormData(form),
            submit = [...form.querySelectorAll("[name]")].filter((el) =>
                el.name.includes("submit")
            );

        // adding submit to formData
        formData.append(submit[0].id, "Submit");
        return formData;
    },

    sendForm() {
        const action = document
                .querySelector(".lightbox__content form")
                .getAttribute("action"),
            payload = lightBox.getDataFromLightboxForm();
        squiz.fn.loadSpiner("show");
        squiz.fn.lightboxActions("hide");
        fetch(action, {
            method: "POST",
            body: payload,
        })
            .then((response) => response.text())
            .then((data) => {
                const parser = new DOMParser(),
                    doc = parser.parseFromString(data, "text/html"),
                    contentToAdd =
                        doc.querySelector(".sq-form-summary-semantic") ||
                        doc.querySelector(".lb-thankyou") ||
                        doc.querySelector("form.lb-form"); // form content

                [...doc.querySelectorAll(".lightbox")].map((item) => {
                    item.addEventListener("click", (e) =>
                        lightBox.lightboxOpenClickHandler(e)
                    );
                });
                // lightBox.vars.lvlOfLightboxInLightbox++;

                squiz.fn.loadSpiner("hide");
                squiz.fn.lightboxActions("show");
                try {
                    squiz.fn.lightboxClean();
                    if (doc.querySelector(".sq-form-submit")) {
                        lightBox.changingSubmit(contentToAdd);

                        // maybe it will be error feedback from "email me profile form" then we need to
                        // support "back" button and "email" field
                        const backUrl = localStorage.getItem("targetBackUrl"),
                            email = localStorage.getItem("targetEmail"),
                            backButton = contentToAdd.querySelector(
                                ".form-lightbox__back--link"
                            ),
                            emailHandler = contentToAdd.querySelector(
                                ".hidden-email input"
                            );

                        if (backButton) {
                            backButton.setAttribute(
                                "data-lightbox-ajax-site",
                                backUrl
                            ); //-- back

                            backButton.addEventListener("click", () => {
                                lightBox.vars.lvlOfLightboxInLightbox =
                                    lightBox.vars.lvlOfLightboxInLightbox - 2;
                            });
                        }

                        if (emailHandler && email) {
                            emailHandler.value = email;
                        }
                    }
                    lightBox.selectors.lightboxContentBox.appendChild(
                        contentToAdd
                    );
                } catch (error) {
                    console.error(error);
                    squiz.fn.lightboxActions("hide");
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    },

    lightboxCloseClickHandler: (e) => {
        e.preventDefault();
        squiz.fn.lightboxClean();
        squiz.fn.lightboxActions("hide");
        lightBox.vars.lvlOfLightboxInLightbox = 0;
    },
};

lightBox.init();
